const BACKEND_URL_PROD = 'https://sell-skins.ru'
export const BACKEND_URL = process.env?.NODE_ENV === "development" ? 'http://185.189.12.179:4000' : BACKEND_URL_PROD
